/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
  Card,
  CardContent,
  CardActions,
  Dialog,
  DialogContent,
  DialogActions,
  Slider,
  IconButton,
  TextField,
  Collapse,
  Tabs,
  Tab,
} from "@mui/material";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "../style/cards.css";
import { AttachFile } from "@mui/icons-material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FaChevronDown } from "react-icons/fa"; // For smooth arrow icon
import "../login/Login.css";

const TaskUpdate = () => {
  const [open, setOpen] = useState(false);
  const [progress, setProgress] = useState(0);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(true);
  const { mode } = useParams();
  const workflowMode = mode === "employee" ? "employee" : "own"; // "own" or "employee"
  const [employeeTasks, setEmployeeTasks] = useState({
    ongoing: [],
    inreview: [],
    completed: [],
  });
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [rejectNote, setRejectNote] = useState("");
  const [rejectTaskDetails, setRejectTaskDetails] = useState(null);
  const [expandedTasks, setExpandedTasks] = useState({}); // State for accordion behavior

  const toggleTaskExpand = (taskId) => {
    setExpandedTasks((prev) => ({ ...prev, [taskId]: !prev[taskId] }));
  };
  const [loadingFiles, setLoadingFiles] = useState({}); // Track loading per file

  // const [tasks, setTasks] = useState([]);
  const [tasks, setTasks] = useState({
    pending: [],
    ongoing: [],
    inreview: [],
    completed: [],
  });
  const [admin, setAdmin] = useState([]);
  const [project, setProject] = useState([]);
  const [employee, setEmployees] = useState([]);
  const [subtask, setSubTasks] = useState([]);
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [descriptionDialogOpen, setDescriptionDialogOpen] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [newUpdateFile, setNewUpdateFile] = useState(null); // Added for initial submit attachment
  const [minProgress, setMinProgress] = useState(0); // Minimum progress tracking
  const fileInputRef = useRef(null); // Reference for file input
  const messagesEndRef = useRef(null); // Reference for chat scroll
  const userData = JSON.parse(localStorage.getItem("user")) || {};
  const userId = userData.id || userData.employee_id || userData.EMP_Id || userData.Admin_id || userData.admin_id;
  const role = localStorage.getItem("role");
  const [recentUpdates, setRecentUpdates] = useState(new Set()); //state for recetupdated subtask
  const getDueDateColor = (toDate) => {
    if (!toDate) {
      // alert("ToDate is missing!"); // Shows alert if the date is missing
      return "#666"; // Default color if no date is provided
    }
    // alert("Received ToDate: " + toDate); // Show the date before processing
    // Convert "DD-MM-YYYY" to "YYYY-MM-DD" for correct Date parsing
    const [day, month, year] = toDate.split("-");
    const formattedDate = new Date(`${year}-${month}-${day}T00:00:00`);
    if (isNaN(formattedDate)) {
      // alert("Invalid Date Format: " + toDate); //Show error alert
      return "#666"; // Return default if date is invalid
    }
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Remove time from system date
    const timeDiff = formattedDate - currentDate;
    const daysRemaining = timeDiff / (1000 * 60 * 60 * 24); // Convert to days
    // alert("Days Remaining: " + daysRemaining); //  Show days difference
    if (daysRemaining === 0) {
      return "green"; //  Task is due today
    } else if (daysRemaining < 0) {
      return "red"; //  Missed Deadline (Past Date)
    } else if (daysRemaining <= 2) {
      return "orange"; //  Due in 2 Days or Less
    } else {
      return "black"; // Normal
    }
  };
  const extractToDate = (taskDuration) => {
    if (!taskDuration) return null; // If empty, return null
    const dates = taskDuration.split(" - "); // Split by " - "
    return dates.length > 1 ? dates[1] : null; // Return the second date (ToDate)
  };

  //fetch tasks from API
  const fetchTasks = async (showLoader = true) => {
    if (showLoader) setLoading(true);
    try {
      const response = await axios.get(
        `/api/task/employee/${userId}`
      );
      const allTasks = response.data.task;
      const taskData = allTasks.map((t, index) => ({
        TaskId: t.project_task_id || `temp-${index}`, // Assign a fallback ID if missing
        ProjectId: t.project_task_project_id,
        TaskAssignTo: t.project_task_assignto,
        TaskAssignBy: t.project_task_assignby,
        Priority: t.project_task_priority,
        TaskTitle: t.project_task_title,
        TaskDescription: t.project_task_Description,
        TaskDuration: t.project_task_duration,
        TaskIsStart: t.project_task_isstart,
        TaskIsCompleted: t.project_task_iscompleted,
        TaskIsActive: t.project_task_isactive,
        TaskStatus: t.project_task_status,
        TaskFile: t.project_task_attach_file,
      }));
      // Fix: Categorize tasks correctly
      const categorizedTasks = {
        Pending: taskData.filter(
          (t) => t.TaskStatus === "Pending" || t.TaskStatus === "on hold"
        ),
        Ongoing: taskData.filter((t) => t.TaskStatus === "Ongoing"),
        InReview: taskData.filter((t) => t.TaskStatus === "InReview"),
        Completed: taskData.filter((t) => t.TaskStatus === "Completed"),
      };
      setTasks(categorizedTasks); // Fix: Now setting categorized tasks correctly

      if (role === "manager" || role === "admin" || role === "Team Leader") {
        const empResponse = await axios.get('/api/tasks');
        const empAllTasks = empResponse.data.task || [];
        const empTaskData = empAllTasks.map((t, index) => ({
          TaskId: t.project_task_id || `temp-emp-${index}`,
          ProjectId: t.project_task_project_id,
          TaskAssignTo: t.project_task_assignto,
          TaskAssignBy: t.project_task_assignby,
          Priority: t.project_task_priority,
          TaskTitle: t.project_task_title,
          TaskDescription: t.project_task_Description,
          TaskDuration: t.project_task_duration,
          TaskIsStart: t.project_task_isstart,
          TaskIsCompleted: t.project_task_iscompleted,
          TaskIsActive: t.project_task_isactive,
          TaskStatus: t.project_task_status,
          TaskFile: t.project_task_attach_file,
        }));

        const actualEmpTasks = empTaskData.filter(t => String(t.TaskAssignTo) !== String(userId));
        const categorizedEmpTasks = {
          Ongoing: actualEmpTasks.filter((t) => t.TaskStatus === "Ongoing"),
          InReview: actualEmpTasks.filter((t) => t.TaskStatus === "InReview"),
          Completed: actualEmpTasks.filter((t) => t.TaskStatus === "Completed"),
        };
        setEmployeeTasks(categorizedEmpTasks);
      }

    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
    if (showLoader) setLoading(false);
  };

  const fetchAdmin = async (showLoader = true) => {
    if (showLoader) setLoading(true);
    try {
      const adminResponse = await axios.get(
        "/api/admin"
      );
      const adminData = adminResponse.data.admin.map((a) => ({
        Admin_id: a.admin_id,
        FullName: a.admin_fullname,
      }));
      setAdmin(adminData);
    } catch (error) {
      console.error("Error fetching admin data:", error);
    }
    if (showLoader) setLoading(false);
  };

  const fetchSubTasks = async (TaskId) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `/api/subtasks/projecttask/${TaskId}`
      );
      if (response.status === 200) {
        // If tasks are found, update the subtask list
        const subTaskData = response.data.subtasks.map((t) => ({
          TUM_Id: t.task_update_id || t.TUM_Id,
          TUM_PTM_Id: t.task_ptm_id || t.TUM_PTM_Id,
          TUM_UpdatedBy: t.task_Updateby || t.TUM_UpdateBy,
          TUM_Progress: t.task_progress || t.TUM_Progress,
          TUM_Comment: t.task_comment || t.TUM_Comment,
          TUM_IsActive: t.task_isactive !== undefined ? t.task_isactive : t.TUM_IsActive,
          TUM_Attach_File: t.task_attach_file || t.TUM_Attach_File,
          created_at: t.task_created_at || t.created_at,
          updated_at: t.task_updated_at || t.updated_at,
        }));
        setSubTasks(subTaskData);

        // Calculate the maximum progress to set as the baseline (minProgress)
        const maxProg = subTaskData.length > 0 ? Math.max(...subTaskData.map(st => Number(st.TUM_Progress) || 0)) : 0;
        setMinProgress(maxProg);
        setProgress(maxProg);
      } else if (
        response.status === 404 &&
        response.data.message === "No Subtasks found for the given employee."
      ) {
        console.log("No sub-tasks found. Adding a new task...");
        await handleAddSubTask(TaskId);
      }
    } catch (error) {
      console.error("Error fetching subtasks:", error);
    }
    setLoading(false);
  };

  // Fetch Project data from the API
  const fetchProject = async (showLoader = true) => {
    if (showLoader) setLoading(true);
    try {
      const response = await axios.get(
        "/api/projects"
      );
      const projectData = response.data.project.map((project) => ({
        ProjectId: project.project_id,
        ProjectName: project.project_name,
      }));
      setProject(projectData);
    } catch (error) {
      console.error("Error fetching project data:", error);
    }
    if (showLoader) setLoading(false);
  };

  const fetchEmployees = async (showLoader = true) => {
    if (showLoader) setLoading(true);
    try {
      const response = await axios.get(
        "/api/emp"
      );
      // Filter both employees and managers
      const employeeData = response.data.employees
        .filter(
          (emp) =>
            emp.employee_role === "E" ||
            emp.employee_role === "M" ||
            emp.employee_role === "T"
        ) // Include both roles
        .map((emp) => ({
          Employee_id: emp.employee_id,
          EmployeeName: `${emp.employee_first_name} ${emp.employee_last_name}`, // Full name
          Role: emp.employee_role, // Include role for reference
        }));
      setEmployees(employeeData);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
    if (showLoader) setLoading(false);
  };

  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);
      await Promise.all([
        fetchTasks(false),
        fetchAdmin(false),
        fetchProject(false),
        fetchEmployees(false)
      ]);
      setLoading(false);
    };
    fetchAllData();

    const interval = setInterval(() => {
      fetchTasks(false); // Background sync every hour
    }, 60 * 60 * 1000); // 1 hour

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  useEffect(() => {
    if (open && messagesEndRef.current) {
      setTimeout(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [subtask, open]);

  // Handle drag event
  const handleDragEnd = async (result) => {
    if (!result.destination) return;
    const { source, destination } = result;
    const sourceColumn = source.droppableId;
    const destinationColumn = destination.droppableId;

    if (sourceColumn === "Completed") return; // Cannot drag out of Completed
    if (workflowMode === "own" && destinationColumn === "Completed") return; // Employee cannot drag into Completed in their own workflow

    const activeTasks = workflowMode === "employee" ? employeeTasks : tasks;
    const setActiveTasks = workflowMode === "employee" ? setEmployeeTasks : setTasks;

    // Prevent moving tasks back to Pending from any other column
    if (sourceColumn !== "Pending" && destinationColumn === "Pending") {
      toast.error("Tasks cannot be moved back to Pending!");
      return;
    }

    // If dropped in the exact same spot, do nothing
    if (sourceColumn === destinationColumn && source.index === destination.index) {
      return;
    }

    if (sourceColumn === destinationColumn) {
      // Reordering within the same column
      const updatedSourceTasks = Array.from(activeTasks[sourceColumn]);
      const [movedTaskToReorder] = updatedSourceTasks.splice(source.index, 1);
      updatedSourceTasks.splice(destination.index, 0, movedTaskToReorder);

      setActiveTasks((prevTasks) => ({
        ...prevTasks,
        [sourceColumn]: updatedSourceTasks,
      }));
      return; // No need to hit API if status didn't change
    }

    // Moving to a different column
    const movedTask = {
      ...activeTasks[sourceColumn][source.index],
      TaskStatus: destinationColumn
    };

    if (workflowMode === "employee") {
      if (sourceColumn === "Ongoing" && destinationColumn === "InReview") {
        toast.error("Employee must submit their own tasks for review.");
        return;
      }
      if (sourceColumn === "InReview" && destinationColumn === "Ongoing") {
        setRejectTaskDetails({
          taskId: movedTask.TaskId,
          newStatus: "Ongoing",
          sourceColumn,
          destinationColumn,
          sourceIndex: source.index,
          destinationIndex: destination.index,
          movedTask
        });
        setIsRejectModalOpen(true);
        return; // Wait for modal submission
      }
      if (destinationColumn === "Completed" && sourceColumn !== "InReview") {
        toast.error("Can only mark In Review tasks as Completed.");
        return;
      }
    }

    const updatedSourceTasks = Array.from(activeTasks[sourceColumn]);
    updatedSourceTasks.splice(source.index, 1);

    const updatedDestinationTasks = Array.from(activeTasks[destinationColumn]);
    updatedDestinationTasks.splice(destination.index, 0, movedTask);

    setActiveTasks((prevTasks) => ({
      ...prevTasks,
      [sourceColumn]: updatedSourceTasks,
      [destinationColumn]: updatedDestinationTasks,
    }));

    // Status update logic
    try {
      await axios.put(
        `/api/task/${movedTask.TaskId}/status`,
        { project_task_status: destinationColumn }
      );
      if (destinationColumn === "InReview") {
        toast.success("Task marked as InReview. Waiting for admin approval.");
      } else {
        toast.success(`Task marked as ${destinationColumn}`);
      }
    } catch (error) {
      console.error("Error updating task status:", error);
      toast.error("Failed to update task status.");
      fetchTasks(); // Only fetch again to revert UI if it failed
    }
  };

  const submitRejectNote = async () => {
    if (!rejectNote.trim()) {
      toast.error("Please enter a note.");
      return;
    }
    const { taskId, newStatus, sourceColumn, destinationColumn, sourceIndex, destinationIndex, movedTask } = rejectTaskDetails;

    // Optimistic UI update
    const updatedSourceTasks = Array.from(employeeTasks[sourceColumn]);
    updatedSourceTasks.splice(sourceIndex, 1);
    const updatedDestinationTasks = Array.from(employeeTasks[destinationColumn]);
    updatedDestinationTasks.splice(destinationIndex, 0, movedTask);

    setEmployeeTasks((prev) => ({
      ...prev,
      [sourceColumn]: updatedSourceTasks,
      [destinationColumn]: updatedDestinationTasks,
    }));

    try {
      const payload = { project_task_status: newStatus, reject_note: rejectNote };
      await axios.put(`/api/task/${taskId}/status`, payload);
      toast.success("Task returned to Ongoing with a note.");
    } catch (error) {
      console.error("Error returning task:", error);
      toast.error("Failed to return task.");
      fetchTasks();
    }
    setIsRejectModalOpen(false);
    setRejectNote("");
  };

  const handleAddSubTask = async (TaskId) => {
    const payload = {
      task_ptm_id: TaskId,
      task_Updateby: userId,
      task_progress: "0", // Start progress at 0
      task_comment: "",
      task_isactive: true,
      task_attach_file: selectedFile ? selectedFile : "",
      task_created_at: "",
      task_updated_at: "",
    };
    try {
      const response = await axios.post(
        "/api/subtask/add",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.status === 200) {
        toast.success("Your Progress Updated!");
        fetchSubTasks(TaskId); // Fetch again to update state
      } else {
        toast.error("Failed to create subtask.");
      }
    } catch (error) {
      console.error("Error creating subtask:", error);
      toast.error("Error creating subtask.");
    }
  };

  // const handleProgressChange = (e, val) => {
  //   setProgress((prevProgress) => Math.max(prevProgress, val)); // Prevent decreasing progress
  // };

  // Handle Submit Button Click
  const handleSubmit = async () => {
    if (progress < minProgress) {
      toast.error(`Progress cannot be less than ${minProgress}%`);
      return;
    }

    const payload = {
      task_ptm_id: selectedTaskId,
      task_Updateby: userId,
      task_progress: progress.toString(),
      task_comment: comment,
      task_isactive: true,
      task_attach_file: "",
      task_created_at: new Date().toISOString(),
      task_updated_at: new Date().toISOString(),
    };

    try {
      const response = await fetch("/api/subtask/add", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("Progress updated successfully!");

        // If a file was selected, upload it to the newly created subtask
        if (newUpdateFile) {
          const newTUMId = result.id || result.data?.id || result.task_update_id || result.data?.task_update_id || result.TUM_Id;

          if (newTUMId) {
            await handleFileUpload({ target: { files: [newUpdateFile] } }, newTUMId);
          } else {
            // Fallback: Fetch subtasks to find the latest ID
            const subRes = await axios.get(`/api/subtasks/projecttask/${selectedTaskId}`);
            if (subRes.status === 200 && subRes.data.subtasks.length > 0) {
              const latestSubtask = subRes.data.subtasks[subRes.data.subtasks.length - 1]; // Assuming array appends new at end
              if (latestSubtask) {
                await handleFileUpload({ target: { files: [newUpdateFile] } }, latestSubtask.task_update_id);
              }
            }
          }
        }

        setOpen(false);
        fetchTasks();
      } else {
        toast.error(`Failed to submit: ${result.message || "Unknown error"}`);
      }
    } catch (error) {
      toast.error("Error submitting update: " + error.message);
    }
  };
  // Open description dialog
  const handleSeeMore = (fullDescription) => {
    setSelectedDescription(fullDescription);
    setDescriptionDialogOpen(true);
  };
  // Open dialog & fetch subtasks
  const handleViewSubTasks = async (taskId) => {
    setSubTasks([]);
    setSelectedTaskId(taskId);
    setComment("");
    setNewUpdateFile(null);
    setOpen(true);
    fetchSubTasks(taskId);
  };

  // Handle File Upload
  const handleFileUpload = async (event, selectedTUMId) => {
    const file = event.target.files[0];
    if (!file) return;

    setLoadingFiles((prev) => ({ ...prev, [selectedTUMId]: true })); // Start loader for the specific task
    setSelectedFile(file);
    setSelectedTaskId(selectedTUMId);

    const formData = new FormData();
    formData.append("task_update_id", selectedTUMId);
    formData.append("task_Updateby", userId);
    formData.append("task_progress", progress.toString());
    formData.append("task_comment", comment);
    formData.append("task_isactive", true);
    formData.append("task_attach_file", file);
    formData.append("task_updated_at", new Date().toISOString());

    try {
      const response = await axios.post(
        `/api/subtask/add-attachment/${selectedTUMId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.status === 200 || response.status === 201) {
        toast.success("File uploaded successfully!");
        fetchSubTasks(selectedTUMId);
      } else {
        toast.error("Failed to upload file.");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      const serverMessage = error.response?.data?.message || error.response?.data?.error;
      const validationErrors = error.response?.data?.errors ? Object.values(error.response.data.errors).flat().join(', ') : null;
      
      if (validationErrors) {
        toast.error(validationErrors);
      } else if (serverMessage) {
        toast.error(`Upload Failed: ${serverMessage}`);
      } else {
        toast.error(
          "File Type Must Be: pdf, doc, docx, xlsx, csv, txt, png, jpg, jpeg (Max 10MB)"
        );
      }
    } finally {
      setLoadingFiles((prev) => ({ ...prev, [selectedTUMId]: false })); // Stop loader for the specific task
    }
  };

  // Function to handle status update
  const handleStatusChange = async (taskId, newStatus) => {
    console.log("status-->", newStatus);
    if (!newStatus) {
      toast.error("Invalid status update");
      return;
    }
    try {
      const response = await axios.put(
        `/api/task/${taskId}/status`,
        { project_task_status: newStatus },
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.status === 200) {
        toast.success(`Task marked as ${newStatus}`);
        fetchTasks(); // Refresh task list after update
      } else {
        toast.error("Failed to update task status.");
      }
    } catch (error) {
      console.error("Error updating task status:", error);
      toast.error("Error updating task status.");
    }
  };
  // Identify newly updated subtasks
  useEffect(() => {
    if (subtask.length > 0) {
      // Identify newly updated subtasks (where updated_at has changed)
      const updatedTaskIds = new Set(
        subtask
          .filter((st) => new Date(st.updated_at) > Date.now() - 30000) // Tasks updated within 1 min
          .map((st) => st.TUM_Id)
      );
      setRecentUpdates(updatedTaskIds);
      // Remove highlight after 1 minute
      const timer = setTimeout(() => {
        setRecentUpdates(new Set());
      }, 30000);
      return () => clearTimeout(timer);
    }
  }, [subtask]); // Runs whenever `subtask` updates
  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <ToastContainer />
      <div className="task-container">
        {Object.entries(workflowMode === "employee" ? employeeTasks : tasks).map(([status, taskList]) => (
          <Droppable key={status} droppableId={status} isDropDisabled={false} isCombineEnabled={false} ignoreContainerClipping={false}>
            {(provided) => (
              <div
                className="task-column"
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                <h3>{status.toUpperCase()}</h3>
                {taskList && taskList.map((task, index) =>
                  task && task.TaskId ? (
                    <Draggable
                      key={task.TaskId}
                      draggableId={task.TaskId.toString()}
                      index={index}
                      isDragDisabled={status === "Completed"}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...(status !== "Completed"
                            ? provided.draggableProps
                            : {})}
                          {...(status !== "Completed"
                            ? provided.dragHandleProps
                            : {})}
                          style={{
                            ...((status !== "Completed" ? provided.draggableProps.style : {}) || {}),
                            outline: "none",
                            width: snapshot.isDragging ? undefined : "100%"
                          }}
                        >
                          <Card
                            className={`task-card task-status-${task.TaskStatus?.toLowerCase() || "default"
                              } ${expandedTasks[task.TaskId] ? 'task-card-expanded' : ''} ${snapshot.isDragging ? 'task-card-dragging' : ''}`}
                            style={{
                              cursor: "grab",
                              userSelect: "none",
                              WebkitUserSelect: "none",
                              MozUserSelect: "none",
                              msUserSelect: "none"
                            }}
                          >
                            <CardContent style={{ paddingBottom: expandedTasks[task.TaskId] ? "8px" : "16px" }}>
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <Typography
                                  variant="h6"
                                  fontWeight="bold"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleTaskExpand(task.TaskId);
                                  }}
                                  style={{ cursor: "pointer", flex: 1 }}
                                >
                                  {task.TaskTitle}
                                </Typography>
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleTaskExpand(task.TaskId);
                                  }}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "28px",
                                    height: "28px",
                                    borderRadius: "50%",
                                    background: expandedTasks[task.TaskId] ? "rgba(59, 130, 246, 0.15)" : "rgba(255, 255, 255, 0.05)",
                                    color: expandedTasks[task.TaskId] ? "#3b82f6" : "var(--text-muted)",
                                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                    transform: expandedTasks[task.TaskId] ? "rotate(180deg)" : "rotate(0deg)",
                                    cursor: "pointer",
                                    marginLeft: "10px"
                                  }}
                                >
                                  <FaChevronDown size={14} />
                                </div>
                              </Box>
                            </CardContent>

                            <Collapse in={expandedTasks[task.TaskId]} timeout="auto" unmountOnExit>
                              <CardContent style={{ paddingTop: 0 }}>
                                <Box>
                                  <Typography variant="body2" color="textSecondary">
                                    Project:{" "}
                                    <strong>
                                      {project.find(
                                        (p) => p.ProjectId === task.ProjectId
                                      )?.ProjectName || "Unknown Project"}
                                    </strong>
                                  </Typography>
                                  <Typography
                                    variant="subtitle2"
                                    color="textSecondary"
                                  >
                                    Assigned By:{" "}
                                    <strong>
                                      {" "}
                                      {employee.some(
                                        (emp) => emp.Employee_id === task.TaskAssignBy
                                      )
                                        ? employee.find(
                                          (emp) =>
                                            emp.Employee_id === task.TaskAssignBy
                                        )?.EmployeeName
                                        : admin.find(
                                          (a) => a.Admin_id === task.TaskAssignBy
                                        )?.FullName || "Unknown"}
                                    </strong>
                                  </Typography>
                                  {workflowMode === "employee" && (
                                    <Typography
                                      variant="subtitle2"
                                      color="textSecondary"
                                    >
                                      Assigned To:{" "}
                                      <strong style={{ color: "#3b82f6" }}>
                                        {" "}
                                        {employee.some(
                                          (emp) => emp.Employee_id === task.TaskAssignTo
                                        )
                                          ? employee.find(
                                            (emp) =>
                                              emp.Employee_id === task.TaskAssignTo
                                          )?.EmployeeName
                                          : admin.find(
                                            (a) => a.Admin_id === task.TaskAssignTo
                                          )?.FullName || "Unknown"}
                                      </strong>
                                    </Typography>
                                  )}
                                  <Typography
                                    variant="subtitle2"
                                    color="textSecondary"
                                  >
                                    Priority:
                                    <Box
                                      className={`priority-badge priority-${task.Priority?.toLowerCase() || "default"
                                        }`}
                                    >
                                      {task.Priority}
                                    </Box>
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    onClick={(e) => {
                                      if (task.TaskDescription && task.TaskDescription.length > 40) {
                                        e.stopPropagation();
                                        handleSeeMore(task.TaskDescription);
                                      }
                                    }}
                                    sx={{
                                      display: "-webkit-box",
                                      WebkitBoxOrient: "vertical",
                                      WebkitLineClamp: 1, // Allow up to 2 lines before truncating
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      cursor: (task.TaskDescription && task.TaskDescription.length > 40) ? "pointer" : "default",
                                    }}
                                    title={(task.TaskDescription && task.TaskDescription.length > 40) ? "Click to read full description" : ""}
                                  >
                                    Description:{" "}
                                    {task.TaskDescription ||
                                      "No description available"}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    style={{
                                      color: getDueDateColor(
                                        extractToDate(task.TaskDuration)
                                      ),
                                    }}
                                  >
                                    Duration:{" "}
                                    {task.TaskDuration
                                      ? task.TaskDuration
                                      : "Date not available"}
                                  </Typography>
                                  {task.TaskFile && (
                                    <img
                                      src="../images/file.png" // Replace with your image path
                                      alt="Open File"
                                      className="open-file-icon"
                                      onClick={() =>
                                        window.open(task.TaskFile, "_blank")
                                      }
                                    />
                                  )}
                                </Box>
                              </CardContent>
                              {task.TaskStatus === "Ongoing" && (
                                <CardActions>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    className="progressbtn"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleViewSubTasks(task.TaskId);
                                    }}
                                  >
                                    Current Progress
                                  </Button>
                                </CardActions>
                              )}
                            </Collapse>
                          </Card>
                        </div>
                      )}
                    </Draggable>
                  ) : null
                )}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        ))}
        <Box>
          {/* Dialog for Full Description */}
          <Dialog
            open={descriptionDialogOpen}
            onClose={() => setDescriptionDialogOpen(false)}
            PaperProps={{
              style: {
                backgroundColor: "#1e2235",
                borderRadius: "16px",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.6)",
                color: "#ffffff",
                minWidth: "350px",
                maxWidth: "500px",
              },
            }}
          >
            <DialogContent sx={{ padding: "24px 24px 16px" }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                  paddingBottom: "12px",
                  marginBottom: "16px",
                  color: "#e2e8f0"
                }}
              >
                Task Description
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  lineHeight: 1.6,
                  color: "#cbd5e1",
                  fontSize: "15px",
                  whiteSpace: "pre-wrap"
                }}
              >
                {selectedDescription}
              </Typography>
            </DialogContent>
            <DialogActions sx={{ padding: "16px 24px", paddingTop: "0" }}>
              <Button
                onClick={() => setDescriptionDialogOpen(false)}
                sx={{
                  backgroundColor: "rgba(239, 68, 68, 0.1)",
                  color: "#ef4444",
                  fontWeight: "600",
                  textTransform: "none",
                  borderRadius: "8px",
                  padding: "6px 20px",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#ef4444",
                    color: "#ffffff",
                  },
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </div>
      {/* Dialog for Updating Progress */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth PaperProps={{ style: { borderRadius: "16px", background: "#1e293b", color: "#f8fafc", border: "1px solid #334155", boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)" } }}>
        <DialogContent style={{ padding: "24px" }}>
          <Typography variant="h5" style={{ fontWeight: "bold", marginBottom: "20px", textAlign: "center" }}>
            Task Progress & Updates
          </Typography>

          {/* Subtasks Section - Chat Layout */}
          {subtask.length > 0 && (
            <Box className="hide-scrollbar" style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "30px", maxHeight: "400px", overflowY: "auto", padding: "16px", background: "rgba(15, 23, 42, 0.4)", borderRadius: "12px", border: "1px solid rgba(255,255,255,0.05)" }}>
              {subtask.map((st) => {
                const updaterName = employee.find(emp => emp.Employee_id === st.TUM_UpdatedBy)?.EmployeeName || admin.find(a => a.Admin_id === st.TUM_UpdatedBy)?.FullName || "Unknown";

                const userProfile = JSON.parse(localStorage.getItem("userProfile")) || {};
                const loggedInName = role === "admin"
                  ? (userProfile?.admin_fullname || userData?.FullName || userData?.admin_fullname || "")
                  : `${userProfile?.employee_first_name || userData?.EMP_F_Name || ''} ${userProfile?.employee_last_name || userData?.EMP_L_Name || ''}`.trim();

                const isMyUpdate = String(st.TUM_UpdatedBy) === String(userId) || (updaterName?.toLowerCase() === loggedInName?.toLowerCase() && updaterName !== "Unknown");

                return (
                  <Box key={st.TUM_Id} style={{ display: "flex", justifyContent: isMyUpdate ? "flex-end" : "flex-start", width: "100%" }}>
                    <Box sx={{
                      maxWidth: "75%",
                      padding: "10px 14px",
                      borderRadius: isMyUpdate ? "16px 16px 4px 16px" : "16px 16px 16px 4px",
                      background: isMyUpdate ? "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)" : "#334155",
                      color: "#fff",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                    }}>
                      {!isMyUpdate && (
                        <Typography style={{ fontSize: "12px", color: "#93c5fd", fontWeight: "bold", marginBottom: "4px" }}>
                          {updaterName}
                        </Typography>
                      )}

                      <Typography style={{ fontSize: "14px", marginBottom: "4px", lineHeight: "1.4", wordBreak: "break-word" }}>
                        {st.TUM_Comment}
                      </Typography>

                      <Box style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "15px", marginTop: "6px" }}>
                        <span style={{ fontSize: "10px", color: isMyUpdate ? "rgba(255,255,255,0.7)" : "#cbd5e1" }}>
                          {(st.updated_at || st.created_at) ? new Date(st.updated_at || st.created_at).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: true }).toUpperCase() : ""}
                        </span>

                        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                          <span style={{ fontSize: "10px", background: isMyUpdate ? "rgba(255,255,255,0.2)" : "rgba(16, 185, 129, 0.2)", color: isMyUpdate ? "#fff" : "#10b981", padding: "2px 6px", borderRadius: "10px", fontWeight: "bold" }}>
                            {st.TUM_Progress}%
                          </span>

                          {st.TUM_Attach_File ? (
                            <a href={st.TUM_Attach_File} target="_blank" rel="noopener noreferrer" style={{ color: isMyUpdate ? "#fff" : "#38bdf8", textDecoration: "none", display: "flex", alignItems: "center" }}>
                              <AttachFile style={{ fontSize: "16px" }} />
                            </a>
                          ) : (
                            <IconButton component="label" size="small" style={{ color: isMyUpdate ? "rgba(255,255,255,0.7)" : "#94a3b8", padding: "2px" }}>
                              <AttachFile style={{ fontSize: "14px" }} />
                              <input type="file" hidden onChange={(event) => handleFileUpload(event, st.TUM_Id)} />
                            </IconButton>
                          )}
                        </div>
                      </Box>
                    </Box>
                  </Box>
                );
              })}
              <div ref={messagesEndRef} />
            </Box>
          )}

          <Typography variant="subtitle1" style={{ fontWeight: "bold", marginBottom: "6px" }}>Add New Update</Typography>
          <Box style={{ background: "rgba(255,255,255,0.03)", padding: "12px", borderRadius: "12px", border: "1px solid rgba(255,255,255,0.05)" }}>
            <Box style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
              <Typography style={{ minWidth: "100px", fontSize: "14px" }}>Progress: {progress}%</Typography>
              <Slider
                value={progress}
                onChange={(e, val) => setProgress(val)}
                min={minProgress} // Locked to minimum progress
                max={100}
                step={10}
                valueLabelDisplay="auto"
                style={{ marginLeft: "15px", padding: "10px 0" }}
                size="small"
              />
            </Box>

            <TextField
              label="Task Comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              fullWidth
              multiline
              minRows={1}
              maxRows={3}
              size="small"
              InputLabelProps={{ style: { color: "#94a3b8", fontSize: "14px" } }}
              InputProps={{ style: { color: "var(--text-main)", background: "rgba(0,0,0,0.2)", borderRadius: "8px", fontSize: "14px" } }}
              sx={{ marginBottom: "12px" }}
            />

            <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Button variant="outlined" component="label" style={{ color: "#38bdf8", borderColor: "#38bdf8", textTransform: "none", borderRadius: "8px" }}>
                <AttachFile fontSize="small" style={{ marginRight: "5px" }} /> {newUpdateFile ? "File Selected" : "Attach File"}
                <input type="file" hidden onChange={(e) => setNewUpdateFile(e.target.files[0])} />
              </Button>
              {newUpdateFile && <Typography variant="caption" style={{ color: "#94a3b8" }}>{newUpdateFile.name}</Typography>}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions style={{ padding: "20px 24px", background: "rgba(0,0,0,0.2)" }}>
          <Button onClick={() => setOpen(false)} variant="contained" style={{ background: "#334155", borderColor: "#475569", color: "#f1f5f9", borderRadius: "8px", textTransform: "none", fontWeight: "bold", padding: "6px 20px", boxShadow: "0 4px 6px rgba(0,0,0,0.2)" }}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} variant="contained" style={{ background: "var(--primary)", color: "white", textTransform: "none", borderRadius: "8px", padding: "6px 20px" }}>
            Submit Update
          </Button>
        </DialogActions>
      </Dialog>

      {/* Reject Task Note Modal */}
      <Dialog
        open={isRejectModalOpen}
        onClose={() => setIsRejectModalOpen(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{ style: { borderRadius: "16px", background: "#1e293b", color: "#f8fafc", border: "1px solid #334155" } }}
      >
        <DialogContent style={{ padding: "24px" }}>
          <Typography variant="h6" style={{ marginBottom: "15px", fontWeight: "bold" }}>Return Task to Ongoing</Typography>
          <Typography variant="body2" style={{ marginBottom: "10px", color: "#cbd5e1" }}>Please enter a note explaining what work is remaining:</Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            placeholder="Enter your remarks here..."
            value={rejectNote}
            onChange={(e) => setRejectNote(e.target.value)}
            InputProps={{ style: { color: "var(--text-main)", background: "rgba(0,0,0,0.2)", borderRadius: "8px", fontSize: "14px" } }}
          />
        </DialogContent>
        <DialogActions style={{ padding: "15px", background: "rgba(0,0,0,0.2)" }}>
          <Button onClick={() => {
            setIsRejectModalOpen(false);
            setRejectNote("");
          }} variant="contained" style={{ background: "#334155", borderColor: "#475569", color: "#f1f5f9", borderRadius: "8px", textTransform: "none", fontWeight: "bold", padding: "6px 20px", boxShadow: "0 4px 6px rgba(0,0,0,0.2)" }}>Cancel</Button>
          <Button onClick={submitRejectNote} variant="contained" style={{ background: "var(--primary)", color: "white", textTransform: "none", borderRadius: "8px", padding: "6px 20px" }}>Submit Note</Button>
        </DialogActions>
      </Dialog>
    </DragDropContext>
  );
};
export default TaskUpdate;
